import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {
  MethodAnalysisSources,
  WorksheetAnalysisSources,
} from 'procedures/design/AssayProcedureMethodAnalysisTypes';
import {getJSONPromise} from 'util/Net';

export function fetchAssayProcedureMethodInstanceAnalysisSources(
  worksheetId: string
): Promise<WorksheetAnalysisSources> {
  return getJSONPromise(
    `${getApiBaseForObjectType(DomainGraphType.PROCEDURE)}/${worksheetId}/analysis-sources`
  );
}

export function fetchAssayProcedureMethodDefinitionAnalysisSources(
  pmdvId: string
): Promise<MethodAnalysisSources> {
  return getJSONPromise(
    `${getApiBaseForObjectType(DomainGraphType.PROCEDURE)}/${pmdvId}/method-definition-analysis-sources`
  );
}
